import React from 'react';
import './Moldinghighli.css';

const Moldinghighli = () => {
    return (
        <div className="Generallyin-container">
            <div className='Cavitys'>
                <h2 className="Generallyin-title">Two Platen Injection Molding Machine Highlights</h2>
                <p className="Generallyin-tex">Two platen injection molding machine is generally more flexible
                    for plastic parts with enhanced reliability,
                    higher machine uptime and greater productivity.
                </p>
                <p className="Generallyin-date">Space-saving</p>
                <p className="Generallyin-tex">
                    The length of the two-platen machine in the same tonnage is about 10-20% shorter
                    than the three-platen machine,
                    Saving machine floor space and reducing plant rental expenses.</p>
                <p className="Generallyin-date">Fast mold opening speed</p>
                <p className="Generallyin-tex"> Adopt low-pressure rapid mold opening & closing cylinder,
                    plus multi-stage proportional pressure control to ensure low-pressure mold protection,
                    standard high-speed mold-moving proportional valve; Fast mold opening speed,
                    shortens production cycle and improves production efficiency.</p>
                <p className="Generallyin-date">Large Mold Opening Stroke </p>
                <p className="Generallyin-tex">The mold opening stroke is not restricted by the structure. Mold opening &
                    closing strokes can be increased according to the process requirements! There is no need to purchase
                    a larger three-platen machine, reducing machine investment costs.</p>
                <p className="Generallyin-tex">After a lot of market research, Powerjet has designed and
                    developed a high-efficiency and energy-saving two-plate injection molding machine
                    specializing in the production of various plastic pallets.</p>
            </div>

        </div>
    );
};

export default Moldinghighli;
